import { InfoCircleFilled } from '@ant-design/icons';
import { Popover } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const InfoIconWrapper = styled.div`
  position: absolute;
  left: 10px;
  top: 10px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: auto;
  font-size: 18px;
  color: ${props => props.theme.colorInfo};
  background-color: #fff;
  box-shadow: 0px 0px 14px 10px #fff;
`;

const InfoButton = styled.button`
  all: unset;
  display: flex;
  cursor: pointer;
  border-radius: 50%;
  &:focus-visible {
    outline: 2px solid ${props => props.theme.colorInfo};
    outline-offset: 2px;
    box-shadow: 0 0 0 2px #fff;
  }
`;

const PopoverContent = styled.div`
  max-width: 300px;
`;

export type ContentHoverInfoAssociationType =
  | 'PRINCIPALE'
  | 'SECONDARIO'
  | 'DINAMICO'
  | 'INTEGRAZIONE';

export interface IContentHoverInfoIconProps {
  associationType?: ContentHoverInfoAssociationType;
  className?: string;
}

export function ContentHoverInfoIcon({
  associationType,
  className,
}: Readonly<IContentHoverInfoIconProps>) {
  const { t } = useTranslation();

  const { title, content } = (() => {
    switch (associationType) {
      case 'PRINCIPALE':
        return {
          title: t(
            'button.content-hover-edit-info-principale-title',
            'Modulo principale della Domanda',
          ),
          content: t(
            'button.content-hover-edit-info-principale',
            'È sempre richiesto e viene presentato per primo in compilazione.',
          ),
        };
      case 'SECONDARIO':
        return {
          title: t(
            'button.content-hover-edit-info-secondario-title',
            'Modulo secondario',
          ),
          content: t(
            'button.content-hover-edit-info-secondario',
            "Viene presentato dopo il principale, nell'ordine configurato.",
          ),
        };
      case 'DINAMICO':
        return {
          title: t(
            'button.content-hover-edit-info-dinamico-title',
            'Modulo ad attivazione dinamica',
          ),
          content: t(
            'button.content-hover-edit-info-dinamico',
            "Questo modulo si attiva in base alla compilazione di un altro modulo, nell'ordine configurato. Potrebbe non comparire nella compilazione della Domanda.",
          ),
        };
      default:
        return {};
    }
  })();

  if (!content) return null;

  return (
    <InfoIconWrapper className={className}>
      <Popover
        trigger={['hover', 'focus']}
        placement="topLeft"
        arrow={{ pointAtCenter: true }}
        title={title}
        content={<PopoverContent>{content}</PopoverContent>}
      >
        <InfoButton
          type="button"
          aria-label={t(
            'button.content-hover-edit-info-aria-label',
            'Informazioni aggiuntive',
          )}
        >
          <InfoCircleFilled aria-hidden />
        </InfoButton>
      </Popover>
    </InfoIconWrapper>
  );
}
